module.exports = __webpack_public_path__ + "static/media/DocumentBackExample.2565ff43.svg";